import styled from "styled-components";

export const ErrorPageBaseWrapper = styled.div`
  width: 100%;
  background: rgb(231, 240, 248);
  display: flex;
  justify-content: center;
`;

export const ErrorPageWrapper = styled.div`
  margin-top: 32px;
`;

export const TitleWrapper = styled.div`
  font-size: 30px;
  font-weight: 600;
  color: #101828;
  margin-bottom: 16px;
  display: flex;
  justify-content: center;
  text-align: center;
`;

export const DescWrapper = styled.div`
  font-size: 16px;
  color: #475467;
  display: flex;
  justify-content: center;
  text-align: center;
`;

export const ErrorCodeWrapper = styled.div`
  width: 91px;
  height: 28px;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #d0d5dd;
  margin-bottom: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  .txt-error {
    margin-left: 6px;
  }
`;
export const ErrorCodeBaseWrapper = styled.div`
  display: flex;
  justify-content: center;
  text-align: center;
`;
